import React from "react"
import PropTypes from "prop-types"

import { useWidget } from "../../../foundations/Widget"
import { StyledButton } from "./SelectableItem"
import { MenuItem } from "../MenuItem"

export const LinkItem = ({ onClick = undefined }) => {
  const { setIsOpen } = useWidget()

  function handleClick(event) {
    onClick?.(event, setIsOpen)
  }

  return (
    <MenuItem>
      <StyledButton onClick={handleClick} />
    </MenuItem>
  )
}

LinkItem.propTypes = {
  onClick: PropTypes.func,
}
